import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, AutoBalanceTransferDialogueHandler } from '../types';
import AutoBalanceTransferContext from './AutoBalanceTransferContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type AutoBalanceTransferDialogueProps = {
  handleAutoBalanceTransferDialogue: DialogueHandler<AutoBalanceTransferDialogueHandler>;
};

type FC = FunctionComponent<AutoBalanceTransferDialogueProps>;

const AutoBalanceTransferDialogue: FC = ({ handleAutoBalanceTransferDialogue }: AutoBalanceTransferDialogueProps) => {
  const {
    showCancelAutoBalanceTransferConfirmAlert,
    showCancelAutoBalanceTransferErrorAlert,
    showCancelAutoBalanceTransferSuccessAlert,
    cancelAutoBalanceTransferError,
  } = useContext(AutoBalanceTransferContext);

  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.AutoBalanceTransfer.Overview.Modals' });

  return useMemo(
    () => (
      <div>
        {/* Cancel Auto Balance Transfer Confirmation */}
        <ConfirmationDialogue
          isVisible={showCancelAutoBalanceTransferConfirmAlert}
          title={t('CancelTransferConfirmation.title')}
          status="alert"
          subTitle={t('CancelTransferConfirmation.subTitle')}
          confirm={{
            label: t('CancelTransferConfirmation.confirmButton'),
            action: () => handleAutoBalanceTransferDialogue({ type: 'confirm', state: 'confirm' }),
          }}
          cancel={{
            label: t('CancelTransferConfirmation.cancelButton'),
            action: () => handleAutoBalanceTransferDialogue({ type: 'confirm', state: 'fail' }),
          }}
        />
        {/* Cancel Auto Balance Transfer Error */}
        <ConfirmationDialogue
          isVisible={showCancelAutoBalanceTransferErrorAlert}
          title={t('CancelTransferError.title')}
          status="error"
          subTitle={`${cancelAutoBalanceTransferError}`}
          confirm={{
            label: t('CancelTransferError.confirmButton'),
            action: () => handleAutoBalanceTransferDialogue({ type: 'cancel', state: 'fail' }),
          }}
        />
        {/* Cancel Auto Balance Transfer Success */}
        <ConfirmationDialogue
          isVisible={showCancelAutoBalanceTransferSuccessAlert}
          title={t('CancelTransferSuccess.title')}
          status="success"
          subTitle=""
          confirm={{
            label: t('CancelTransferSuccess.confirmButton'),
            action: () => handleAutoBalanceTransferDialogue({ type: 'cancel', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [
      showCancelAutoBalanceTransferConfirmAlert,
      showCancelAutoBalanceTransferErrorAlert,
      showCancelAutoBalanceTransferSuccessAlert,
      cancelAutoBalanceTransferError,
    ],
  );
};

export default AutoBalanceTransferDialogue;
